import { useState } from 'react'
import { trackFromSubmission } from '../helpers/utils'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { getCookie } from 'cookies-next'

const FooterSubscribeForm = () => {
    const [email, setEmail] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState('')
    const [success, setSuccess] = useState(false)
    const [phone, setPhone] = useState('')

    const FORM_NAME = 'Footer Subscribe Form'
    const FORM_DIV_ID = 'footer-subscribe-form'

    const PORTAL_ID = '21994206'
    const FORM_ID = '7bce3d9e-b8a6-4c19-bc6d-0d529061b700'

    const { executeRecaptcha } = useGoogleReCaptcha() // Hook to generate reCAPTCHA token

    const isValidEmail = (email) => {
        return /^[\w.-]+@[\w.-]+\.[\w]{2,4}$/.test(email)
    }

    const isValidPhone = (value) => {
        if (!value) return false
        // Remove all non-digit characters
        const digits = value.replace(/\D/g, '')

        // USA phone numbers should be exactly 10 digits
        // or 11 digits if it starts with country code '1'
        if (digits.length === 10) {
            // Valid 10-digit USA number
            return true
        } else if (digits.length === 11 && digits.startsWith('1')) {
            // Valid with country code +1 or 1
            return true
        }

        return false
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')

        if (!isValidEmail(email)) {
            setError('Please enter a valid email address.')
            return
        }

        if (!isValidPhone(phone)) {
            setError('Please enter a valid phone number.')
            return
        }

        if (!executeRecaptcha) {
            setError('reCAPTCHA not loaded. Please try again.')
            return
        }

        // Generate reCAPTCHA token
        let recaptchaToken
        try {
            recaptchaToken = await executeRecaptcha('subscribe_form') // 'subscribe_form' is an action name
        } catch (err) {
            setError('Error generating reCAPTCHA token. Please try again.')
            return
        }

        const verifyResponse = await fetch('/api/verify-recaptcha', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ recaptchaToken }),
        })
        const { success: rcSuccess, score } = await verifyResponse.json()
        if (!rcSuccess || score < 0.5) {
            // Adjust threshold as needed
            setError('reCAPTCHA verification failed.')
            setIsSubmitting(false)
            return
        }

        setIsSubmitting(true)

        try {
            const fields = [
                { name: 'email', value: email },
                { name: 'phone', value: phone.trim() },
            ]

            const response = await fetch(
                `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        fields,
                        context: {
                            pageUri: window.location.href + '#' + FORM_DIV_ID,
                            pageName: FORM_NAME,
                            hutk: getCookie('hubspotutk'),
                        },
                    }),
                },
            )

            if (response.ok) {
                setSuccess('Thank you for submitting form!')
                onFormSubmission()
                setEmail('')
                setPhone('')
            } else {
                alert('There was an error submitting the form.')
            }
        } catch (error) {
            console.error(error)
        } finally {
            setIsSubmitting(false)
        }
    }

    const onFormSubmission = () => {
        trackFromSubmission(FORM_NAME)
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-10868336784/wuxHCLnL-ooYEJDRtr4o',
            })
        }
    }

    return (
        <div
            id={FORM_DIV_ID}
            className="md:w-8/12 w-full md:flex justify-center md:justify-end h-full">
            <div className="w-full px-4 sm:px-0">
                <h3 className="text-white text-xs font-semibold mb-1 text-center sm:text-left">
                    Join Our Direct To Seller Newsletter
                </h3>

                {success && (
                    <p className="text-white mt-1 text-center sm:text-left">
                        {success}
                    </p>
                )}
                {!success && (
                    <form
                        onSubmit={handleSubmit}
                        id={'hsForm_' + FORM_ID}
                        name={FORM_NAME}
                        data-form-name={FORM_NAME}
                        data-form-id={FORM_ID}
                        data-portal-id={PORTAL_ID}
                        className="w-full md:flex text-center sm:flex-row sm:space-x-2">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your email address"
                            className="md:w-6/12 w-full p-2 mb-2 sm:mb-0 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            required
                        />
                        <input
                            type="tel"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Your phone number"
                            className="md:w-5/12 w-full p-2 mb-2 sm:mb-0 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            required
                        />
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="md:flex-grow w-48 sm:w-auto p-2 bg-black-light-gradient text-white rounded-md font-semibold transition-colors">
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                    </form>
                )}
                {error && (
                    <p className="text-[#5b0f00] text-xs mt-1 text-center sm:text-left">
                        {error}
                    </p>
                )}
            </div>
        </div>
    )
}

export default FooterSubscribeForm
